import { render, staticRenderFns } from "./scheme-advantages-DigitalAgricultureSolutions.vue?vue&type=template&id=c67421bc&scoped=true"
import script from "./scheme-advantages-DigitalAgricultureSolutions.vue?vue&type=script&lang=js"
export * from "./scheme-advantages-DigitalAgricultureSolutions.vue?vue&type=script&lang=js"
import style0 from "./scheme-advantages-DigitalAgricultureSolutions.vue?vue&type=style&index=0&id=c67421bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67421bc",
  null
  
)

export default component.exports